import './styles/quasar.scss';
import iconSet from 'quasar/icon-set/fontawesome-v5';
import '@quasar/extras/roboto-font/roboto-font.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/css/v4-shims.min.css';
import QIcon from 'quasar/src/components/icon/QIcon.js';import QBadge from 'quasar/src/components/badge/QBadge.js';import QChip from 'quasar/src/components/chip/QChip.js';import QImg from 'quasar/src/components/img/QImg.js';import QInput from 'quasar/src/components/input/QInput.js';import QSelect from 'quasar/src/components/select/QSelect.js';import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import QRadio from 'quasar/src/components/radio/QRadio.js';import QBanner from 'quasar/src/components/banner/QBanner.js';import QCard from 'quasar/src/components/card/QCard.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';import QCardActions from 'quasar/src/components/card/QCardActions.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';import QTabs from 'quasar/src/components/tabs/QTabs.js';import QTab from 'quasar/src/components/tabs/QTab.js';import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';import QAvatar from 'quasar/src/components/avatar/QAvatar.js';import QDrawer from 'quasar/src/components/drawer/QDrawer.js';import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';import QLayout from 'quasar/src/components/layout/QLayout.js';import QHeader from 'quasar/src/components/header/QHeader.js';import QFooter from 'quasar/src/components/footer/QFooter.js';import QPage from 'quasar/src/components/page/QPage.js';import QPageContainer from 'quasar/src/components/page/QPageContainer.js';import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';import QList from 'quasar/src/components/item/QList.js';import QItem from 'quasar/src/components/item/QItem.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';import QTable from 'quasar/src/components/table/QTable.js';import QTr from 'quasar/src/components/table/QTr.js';import QTh from 'quasar/src/components/table/QTh.js';import QTd from 'quasar/src/components/table/QTd.js';import QMenu from 'quasar/src/components/menu/QMenu.js';import QPagination from 'quasar/src/components/pagination/QPagination.js';import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';import QSeparator from 'quasar/src/components/separator/QSeparator.js';import QSpace from 'quasar/src/components/space/QSpace.js';import QSpinner from 'quasar/src/components/spinner/QSpinner.js';import QStepper from 'quasar/src/components/stepper/QStepper.js';import QStep from 'quasar/src/components/stepper/QStep.js';import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';import QToggle from 'quasar/src/components/toggle/QToggle.js';import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import Quasar from 'quasar/src/vue-plugin.js';import Dialog from 'quasar/src/plugins/Dialog.js';import Notify from 'quasar/src/plugins/Notify.js';import Meta from 'quasar/src/plugins/Meta.js';;

export default {
  plugin: Quasar,
  options: {
    config: {},
    components: {
      QIcon,
      QBadge,
      QChip,
      QImg,
      QInput,
      QSelect,
      QCheckbox,
      QRadio,
      QBanner,
      QCard,
      QCardSection,
      QCardActions,
      QBtn,
      QBtnDropdown,
      QBtnGroup,
      QBtnToggle,
      QTabs,
      QTab,
      QTabPanels,
      QTabPanel,
      QAvatar,
      QDrawer,
      QExpansionItem,
      QLayout,
      QHeader,
      QFooter,
      QPage,
      QPageContainer,
      QPageSticky,
      QList,
      QItem,
      QItemSection,
      QItemLabel,
      QLinearProgress,
      QMarkupTable,
      QTable,
      QTr,
      QTh,
      QTd,
      QMenu,
      QPagination,
      QRouteTab,
      QScrollArea,
      QSeparator,
      QSpace,
      QSpinner,
      QStepper,
      QStep,
      QToolbar,
      QToolbarTitle,
      QToggle,
      QTooltip,
    },
    directives: {},
    plugins: {
      Dialog,
      Notify,
      Meta,
    },
    iconSet,
  },
};
